<template>
  <div class="flex justify-center">
    <div class="w-full max-w-5xl">
      <div
        class="p-5"
      >
        <div class="flex flex-col gap-5 items-center justify-center">
          <div class="">
            <div class="flex flex-row gap-3">
              <div class="w-fit bg-[var(--p-primary-color)]/20 p-1 rounded-md shrink-0">
                <IconChatTransfer width="30" height="30" class="text-[var(--p-primary-color)]  dark:text-[var(--p-primary-100)]" />
              </div>
              <label
                class="montserrat text-xl sm:text-2xl font-semibold text-[var(--p-primary-color)] dark:text-[var(--p-text-color)]"
              >
                {{ t('whatsapp.transfer_in_progress_title') }}
              </label>
            </div>
          </div>
          <div class="flex flex-row items-center gap-8">
            <label
              class="montserrat mt-1 text-md font-medium text-[var(--p-primary-color)] dark:text-[var(--p-surface-100)]"
            >
              {{ t('whatsapp.transfer_waiting_agent_response') }}
            </label>

            <div
              class=" flex h-[4rem] w-[4rem] shrink-0 items-center justify-center rounded-full bg-[var(--p-primary-color)]/20 text-[var(--p-primary-color)]  dark:text-[var(--p-surface-0)]"
            >
             
              <div class="text-2xl font-medium tabular-nums">
                {{ formattedCountdown }}
              </div>
            </div>
          </div>
        </div>

        <div class="mt-15">
          <TransferSummaryCards
            :contact-name="contactName"
            :contact-phone="contactPhone"
            transfer-type="user"
            :destination-name="destinationName"
            :destination-subtitle="destinationSubtitle"
            :destination-meta="destinationMeta"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import TransferSummaryCards from './TransferSummaryCards.vue'
import IconChatTransfer from '@/assets/svg/transfer_chat_icon.svg?component'

interface Props {
  contactName: string
  contactPhone: string
  destinationName: string
  destinationSubtitle?: string | null
  destinationMeta?: string | null
  countdown: number
}

const props = withDefaults(defineProps<Props>(), {
  destinationSubtitle: null,
  destinationMeta: null,
})

const { t } = useI18n()

const formattedCountdown = computed(() => String(Math.max(props.countdown, 0)).padStart(2, '0'))
</script>
